import { getTiers } from 'actions/tiers'
import useDispatch from 'hooks/useDispatch'
import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { selectTiers } from 'selectors/tier'
import useProfilePermissions from './useProfilePermissions'

// Loads the merchant's tiers for the profile header (TierBadge) and the
// actions menu (Edit tier). Skipped without TiersProgram access, where
// GET /tiers would 403 and toast "Missing permission".
const useProfileTiers = () => {
  const dispatch = useDispatch()
  const { canAccessTiers } = useProfilePermissions()
  const tiers = useSelector(selectTiers)
  const hasTiers = tiers.length > 0

  useEffect(() => {
    if (!canAccessTiers || hasTiers) return

    dispatch(getTiers({}))
  }, [canAccessTiers, dispatch, hasTiers])
}

export default useProfileTiers
